import React from 'react';
import './Nav.css';
import { NavLink } from 'react-router-dom';

class Nav extends React.Component {
  render() {
    return (

      <div className="header-nav">
        <div className="container">
          <nav>
            <ul>
              <li><NavLink to={this.props.link['main']} className="link">Главная</NavLink></li>
              <li><NavLink to={this.props.link['about']} className="link"> О нас</NavLink></li>
              <li><NavLink to={this.props.link['contacts']} className="link">Контакты</NavLink></li>
            </ul>
          </nav>
        </div>
      </div>
    );
  }
}

export default Nav;
